import React, { useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  DialogTitle,
  Button,
} from "@mui/material";
import UserSelect from '../../../components/SelectField/UserSelect';
import { connect } from 'react-redux';
import axios from 'axios';
import { updateAlert } from '../../../redux/actions';
import ModelSelect from '../../../components/SelectField/ModelSelect';

function AddProject({ fullScreen, setReload, createOpen, setCreateOpen, user, role, handleAlert }) {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [goal, setGoal] = useState("");
  const [users, setUsers] = useState([user]);
  const [models, setModels] = useState([]);

  const handleCreateClose = () => {
    setCreateOpen(false);
  };

  const handleSubmit = () => {
    if (!users.find(u => u.id === user.id) && role !== "Admin") {
      handleAlert("error", "Must include yourself as project owner!", 3000)
      return
    }

    // check for required fields
    if (!name || !title || !description || !goal) {
      handleAlert("error", "Please fill all blanks!")
      return
    }

    axios({
      method: "post",
      url: '/api/m2d/projects/createProject',
      data: {
        uid: user.id,
        name,
        title,
        description,
        goal,
        models,
      }
    }).then(() => {
      setCreateOpen(false);
      setReload(curr => !curr)
      handleAlert("success", "Successfully submited!")
    }).catch((err) => {
      handleAlert("error", err.message, 3500)
    })
  };

  return (
    <div className="add-proj-content">
          <Dialog
            fullScreen={fullScreen}
            open={createOpen}
            onClose={handleCreateClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {"Start a new project"}
            </DialogTitle>
            <DialogContent>
              <div className="proj-add-info">
                Your project will be available once we approve.
              </div>

              <UserSelect setUsers={setUsers} users={users} sx={{ marginTop: '10px', marginBottom: '10px' }} />

              <TextField
                required
                label="Name"
                fullWidth
                margin="normal"
                onInput={(e) => setName(e.target.value)}
              />

              <TextField
                required
                label="Title"
                fullWidth
                margin="normal"
                onInput={(e) => setTitle(e.target.value)}
              />

              <TextField
                required
                label="Description"
                fullWidth
                margin="normal"
                multiline
                rows={3}
                onInput={(e) => setDescription(e.target.value)}
              />

              <TextField
                required
                label="Goal"
                fullWidth
                margin="normal"
                multiline
                rows={3}
                onInput={(e) => setGoal(e.target.value)}
              />

              <ModelSelect setModels={setModels} models={models} sx={{ marginTop: '10px', marginBottom: '10px' }} />

            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="error" onClick={handleCreateClose}>
                Discard
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    fullScreen: props.fullScreen,
    setReload: props.setReload,
    createOpen: props.createOpen,
    setCreateOpen: props.setCreateOpen,
    user: state.main.user,
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddProject)
